/* Bundle-Builder (siehe unten) nutzt das Theme-eigene Cart-System für ein
   echtes Multi-Add-to-Cart (POST /cart/add.js mit mehreren Items in einem
   Request) statt der reinen Demo-Optik aus der Design-Referenz. */
import { fetchConfig } from "@theme/utilities";
import { CartAddEvent, CartGroupedSections } from "@theme/events";

/* Tabs (rechts) = Akkordeon */
(function(){
  var items=[].slice.call(document.querySelectorAll('.tacc__i'));
  function setOpen(it,open){var pnl=it.querySelector('.tacc__panel');it.classList.toggle('is-open',open);pnl.style.maxHeight=open?pnl.scrollHeight+'px':null;}
  items.forEach(function(it){ it.querySelector('.tacc__btn').addEventListener('click',function(){setOpen(it,!it.classList.contains('is-open'));}); });
})();
/* Closer-CTA -> direkt in den Warenkorb (triggert echten Buy-Box-Button)
   Hinweis: in der Design-Referenz war der Selektor noch ".buy__cta"
   (Platzhalter-Markup). Die echte Buy Box dieses Themes rendert den
   Add-to-Cart-Button über snippets/add-to-cart-button.liquid mit der
   Klasse "add-to-cart-button" (name="add") — deshalb hier angepasst. */
(function(){
  var c=document.getElementById('closerAdd');
  var realCta=document.querySelector('.add-to-cart-button[name="add"]');
  if(!c||!realCta) return;
  c.addEventListener('click',function(){
    realCta.click(); // legt Standard-/gewählte Variante in den Warenkorb
    // kurzes Feedback
    var orig=c.innerHTML;
    c.innerHTML='<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg> Hinzugefügt';
    setTimeout(function(){ c.innerHTML=orig; },1500);
  });
})();
/* PARALLAX: Elemente mit data-parallax bewegen sich sanft beim Scrollen */
(function(){
  if(window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var els=[].slice.call(document.querySelectorAll('[data-parallax]'));
  if(!els.length) return;
  var ticking=false;
  function update(){
    var vh=window.innerHeight;
    els.forEach(function(el){
      var r=el.getBoundingClientRect();
      var center=r.top+r.height/2;
      var off=(center - vh/2)/vh; // -0.5..0.5
      var amt=parseFloat(el.dataset.parallax)||0.1;
      el.style.setProperty('--py',(-off*amt*100).toFixed(1)+'px');
    });
    ticking=false;
  }
  function onScroll(){ if(!ticking){ requestAnimationFrame(update); ticking=true; } }
  window.addEventListener('scroll',onScroll,{passive:true});
  window.addEventListener('resize',onScroll,{passive:true});
  update();
})();

/* BUNDLE-BUILDER (Cross-Selling): toggeln, Live-Summe, Sammel-Button */
(function(){
  var list=document.getElementById('bundleList');
  if(!list) return;
  var items=[].slice.call(list.querySelectorAll('.bitem'));
  var totalEl=document.getElementById('bundleTotal');
  var countEl=document.getElementById('bundleCount');
  var btn=document.getElementById('bundleBtn');
  function fmt(cents){ return '€'+(cents/100).toFixed(2).replace('.',','); }
  function recalc(){
    var sum=0, n=0;
    items.forEach(function(it){
      var on=it.classList.contains('is-on')||it.classList.contains('is-fixed');
      if(on){ sum+=parseInt(it.dataset.price,10)||0; n++; }
    });
    if(totalEl) totalEl.textContent=fmt(sum);
    if(countEl) countEl.textContent=n+(n===1?' Produkt':' Produkte')+' ausgewählt';
    if(btn) btn.disabled=(n===0);
  }
  items.forEach(function(it){
    if(it.dataset.fixed==='1') return; // PDP-Produkt nicht abwählbar
    it.addEventListener('click',function(){
      it.classList.toggle('is-on');
      recalc();
    });
  });
  function gatherGroupedSectionIds(){
    var sections=[];
    document.dispatchEvent(new CartGroupedSections(sections));
    return Array.from(new Set(sections));
  }

  if(btn){
    btn.addEventListener('click',function(){
      if(btn.disabled||btn.classList.contains('is-loading')) return;
      var chosen=items.filter(function(it){return it.classList.contains('is-on')||it.classList.contains('is-fixed');});
      if(!chosen.length) return;

      var cartItems=chosen.map(function(it){
        var variantId=it.dataset.variantId;
        // Für das fixe PDP-Produkt die AKTUELL gewählte Variante (z. B. Größe/
        // Duft) aus der echten Buy Box übernehmen, falls vorhanden — die
        // Buy-Buttons-Form hat immer die ID "BuyButtons-ProductForm-<section.id>".
        if(it.dataset.fixed==='1'){
          var liveInput=document.querySelector('form[id^="BuyButtons-ProductForm-"] [ref="variantId"]');
          if(liveInput&&liveInput.value) variantId=liveInput.value;
        }
        return variantId?{ id: variantId, quantity: 1 }:null;
      }).filter(Boolean);
      if(!cartItems.length) return;

      var span=btn.querySelector('span');
      var orig=span.textContent;
      btn.disabled=true;
      btn.classList.add('is-loading');
      span.textContent='Wird hinzugefügt …';

      var sectionIds=gatherGroupedSectionIds();
      var body=JSON.stringify({
        items: cartItems,
        sections: sectionIds.join(','),
        sections_url: window.location.pathname
      });

      fetch(FoxTheme.routes.cart_add_url, fetchConfig('json', { body: body }))
        .then(function(res){ return res.json(); })
        .then(function(response){
          btn.classList.remove('is-loading');
          if(response.status){
            btn.disabled=false;
            span.textContent='Fehler – bitte erneut versuchen';
            setTimeout(function(){ span.textContent=orig; },2200);
            return;
          }
          document.dispatchEvent(new CartAddEvent(response, 'pdp-bundle-builder', {
            source: 'pdp-bundle-builder',
            itemCount: cartItems.length,
            sections: response.sections
          }));
          span.textContent=cartItems.length+' im Warenkorb ✓';
          btn.style.background='var(--gold-deep,#C9A23F)';
          setTimeout(function(){ span.textContent=orig; btn.style.background=''; btn.disabled=false; },1600);
        })
        .catch(function(err){
          console.error(err);
          btn.disabled=false;
          btn.classList.remove('is-loading');
          span.textContent='Fehler – bitte erneut versuchen';
          setTimeout(function(){ span.textContent=orig; },2200);
        });
    });
  }
  recalc();
})();

/* Kennzahlen hochzählen (Odometer) */
(function(){
  var els=[].slice.call(document.querySelectorAll('.odo'));
  if(!els.length) return;
  var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function fmt(v,dec){
    if(dec){ return v.toFixed(dec).replace('.',','); }
    return Math.round(v).toLocaleString('de-DE');
  }
  function run(el){
    var to=parseFloat(el.dataset.to)||0;
    var dec=parseInt(el.dataset.dec,10)||0;
    var suf=el.dataset.suffix||'';
    if(reduce){ el.textContent=fmt(to,dec)+suf; return; }
    var dur=1400, start=null;
    function step(ts){
      if(!start) start=ts;
      var p=Math.min((ts-start)/dur,1);
      var eased=1-Math.pow(1-p,3); // easeOutCubic
      el.textContent=fmt(to*eased,dec)+(p===1?suf:'');
      if(p<1) requestAnimationFrame(step);
      else el.textContent=fmt(to,dec)+suf;
    }
    requestAnimationFrame(step);
  }
  if(!('IntersectionObserver' in window)){ els.forEach(run); return; }
  var io=new IntersectionObserver(function(entries){
    entries.forEach(function(en){ if(en.isIntersecting){ run(en.target); io.unobserve(en.target); } });
  },{threshold:.5});
  els.forEach(function(e){ io.observe(e); });
})();

/* Reveal */
(function(){
  var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var els=[].slice.call(document.querySelectorAll('.reveal,.rv,.rv-stagger,.rv-clip'));
  if(reduce || !('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('in');});return;}
  var io=new IntersectionObserver(function(entries){entries.forEach(function(en){if(en.isIntersecting){en.target.classList.add('in');io.unobserve(en.target);}});},{threshold:.12,rootMargin:'0px 0px -6% 0px'});
  els.forEach(function(e){io.observe(e);});
})();

/* SET-AKKORDEON (nur pdp-set-products.liquid): "Was steckt in deinem Set?" */
(function(){
  var items=[].slice.call(document.querySelectorAll('.pacc-i'));
  if(!items.length) return;
  function setOpen(it,open){
    var a=it.querySelector('.pacc-a'), btn=it.querySelector('.pacc-q');
    it.classList.toggle('is-open',open);
    btn.setAttribute('aria-expanded',open?'true':'false');
    a.style.maxHeight = open ? (a.scrollHeight+'px') : '0px';
  }
  items.forEach(function(it){
    setOpen(it, it.classList.contains('is-open'));
    it.querySelector('.pacc-q').addEventListener('click',function(){
      var open=!it.classList.contains('is-open');
      items.forEach(function(o){ if(o!==it) setOpen(o,false); });
      setOpen(it,open);
    });
  });
  window.addEventListener('resize',function(){
    items.forEach(function(it){ if(it.classList.contains('is-open')){ var a=it.querySelector('.pacc-a'); a.style.maxHeight=a.scrollHeight+'px'; } });
  });
})();

/* SET-MODALS (nur pdp-set-products.liquid): Nährwerte & Inhaltsstoffe je Produkt */
(function(){
  var modals=document.querySelectorAll('.pmodal');
  if(!modals.length) return;
  function open(id){var m=document.querySelector('.pmodal[data-modal-panel="'+id+'"]');if(m){m.classList.add('is-open');m.setAttribute('aria-hidden','false');document.body.classList.add('modal-open');}}
  function closeAll(){document.querySelectorAll('.pmodal.is-open').forEach(function(m){m.classList.remove('is-open');m.setAttribute('aria-hidden','true');});document.body.classList.remove('modal-open');}
  document.querySelectorAll('.ptp__more').forEach(function(b){b.addEventListener('click',function(){open(b.dataset.modal);});});
  document.querySelectorAll('[data-close]').forEach(function(x){x.addEventListener('click',closeAll);});
  document.addEventListener('keydown',function(e){if(e.key==='Escape')closeAll();});
})();

/* ============================================================
   MANIA HAIR BOOSTER — neue PDP-Sections ab "Was dieses Produkt
   ausmacht" (Referenz: mania-pdp-hairbooster.html). Odometer
   (.odo) und Reveal (.rv/.rv-stagger) laufen bereits über die
   bestehenden Handler weiter oben in dieser Datei mit.
   ============================================================ */

/* USP-Reihe (pdp-usp-stack.liquid): Sublines sind dauerhaft sichtbar (kein
   Scroll-Ein-/Ausklapp-Effekt mehr, siehe .urow__sub in mania-pdp.css). */

/* Nutzen-Timeline (pdp-benefit-timeline.liquid): Desktop Gold-Linie/Dots, Mobile Swipe */
(function(){
  var tl=document.getElementById('tl'), fill=document.getElementById('tlFill');
  var rows=[].slice.call(document.querySelectorAll('#tl .tlrow'));
  if(!tl||!rows.length) return;
  var mqMobile=window.matchMedia('(max-width:700px)');
  var mqRM=window.matchMedia('(prefers-reduced-motion: reduce)');

  function updDesktop(){
    var r=tl.getBoundingClientRect();
    var ref=window.innerHeight*0.52;
    var prog=Math.max(0,Math.min(1,(ref-r.top)/r.height));
    if(fill)fill.style.height=(prog*100)+'%';
    rows.forEach(function(row){
      var dot=row.querySelector('.tl__dot');
      var d=dot?dot.getBoundingClientRect():row.getBoundingClientRect();
      if(d.top < window.innerHeight*0.9) row.classList.add('in');
    });
  }
  function updMobile(){
    rows.forEach(function(r){r.classList.add('in');});
    var mid=tl.scrollLeft+tl.clientWidth/2, best=null, bestD=1e9;
    rows.forEach(function(r){
      var c=r.offsetLeft+r.offsetWidth/2, d=Math.abs(c-mid);
      if(d<bestD){bestD=d;best=r;}
    });
    rows.forEach(function(r){r.classList.toggle('is-current', r===best);});
  }
  function tick(){ if(mqMobile.matches) updMobile(); else updDesktop(); }

  if(mqRM.matches){rows.forEach(function(r){r.classList.add('in');});if(fill)fill.style.height='100%';return;}

  var t=false;
  function onS(){if(!t){requestAnimationFrame(function(){tick();t=false;});t=true;}}
  window.addEventListener('scroll',onS,{passive:true});
  window.addEventListener('resize',function(){onS();setTimeout(tick,60);},{passive:true});
  tl.addEventListener('scroll',onS,{passive:true});
  tick();
})();

/* Inhaltsstoffe-Carousel (pdp-ingredient-carousel.liquid): Pfeil-Navigation */
(function(){
  var track=document.getElementById('ingrTrack');
  var prev=document.getElementById('ingrPrev'), next=document.getElementById('ingrNext');
  if(!track) return;
  function upd(){
    if(!prev||!next)return;
    prev.toggleAttribute('disabled', track.scrollLeft<=4);
    next.toggleAttribute('disabled', track.scrollLeft>=track.scrollWidth-track.clientWidth-4);
  }
  if(prev)prev.addEventListener('click',function(){track.scrollBy({left:-track.clientWidth*0.85,behavior:'smooth'});});
  if(next)next.addEventListener('click',function(){track.scrollBy({left:track.clientWidth*0.85,behavior:'smooth'});});
  track.addEventListener('scroll',function(){requestAnimationFrame(upd);},{passive:true});
  window.addEventListener('resize',upd); upd();
})();

/* Inhaltsstoffe-Modal (pdp-ingredient-carousel.liquid): "Alle ansehen" aus den Karten befüllen */
(function(){
  var open=document.getElementById('ingrOpen'), modal=document.getElementById('ingrModal2');
  var close=document.getElementById('ingrClose'), list=document.getElementById('ingrModalList');
  if(!open||!modal||!list) return;
  var built=false;
  function build(){
    if(built) return;
    var cards=[].slice.call(document.querySelectorAll('#ingrTrack .icard'));
    var html=cards.map(function(c){
      var ic=c.querySelector('.icard__ic'); ic=ic?ic.innerHTML:'';
      var n=c.querySelector('.icard__n'); n=n?n.textContent:'';
      var d=c.querySelector('.icard__d'); d=d?d.textContent:'';
      return '<div class="imodal2__item"><span class="imodal2__ic">'+ic+'</span><div class="imodal2__txt"><div class="imodal2__n">'+n+'</div><div class="imodal2__d">'+d+'</div></div></div>';
    }).join('');
    list.innerHTML=html; built=true;
  }
  function show(){build();modal.classList.add('is-open');modal.setAttribute('aria-hidden','false');document.body.classList.add('modal-open');}
  function hide(){modal.classList.remove('is-open');modal.setAttribute('aria-hidden','true');document.body.classList.remove('modal-open');}
  open.addEventListener('click',show);
  if(close)close.addEventListener('click',hide);
  modal.addEventListener('click',function(e){if(e.target.hasAttribute('data-close'))hide();});
  document.addEventListener('keydown',function(e){if(e.key==='Escape'&&modal.classList.contains('is-open'))hide();});
})();

/* FAQ (pdp-faq.liquid): Akkordeon */
(function(){
  var items=[].slice.call(document.querySelectorAll('.faq2-i'));
  if(!items.length) return;
  function setOpen(it,open){
    var a=it.querySelector('.faq2-a'), btn=it.querySelector('.faq2-q');
    it.classList.toggle('is-open',open);
    btn.setAttribute('aria-expanded',open?'true':'false');
    a.style.maxHeight = open ? (a.scrollHeight+'px') : '0px';
  }
  items.forEach(function(it){
    setOpen(it, it.classList.contains('is-open'));
    it.querySelector('.faq2-q').addEventListener('click',function(){
      var open=!it.classList.contains('is-open');
      items.forEach(function(o){ if(o!==it) setOpen(o,false); });
      setOpen(it,open);
    });
  });
  window.addEventListener('resize',function(){
    items.forEach(function(it){ if(it.classList.contains('is-open')){ var a=it.querySelector('.faq2-a'); a.style.maxHeight=a.scrollHeight+'px'; } });
  });
})();

/* CTA-Closer 3-Dosen (pdp-cta-closer-bundle.liquid): Mengenrabatt-Kachel wählen
   (nutzt den bestehenden Handler aus blocks/_buybox-quantity-tiles.liquid über
   einen echten Klick auf die Kachel) + in den Warenkorb / zur Buy Box scrollen. */
(function(){
  var b3=document.getElementById('closer3Add'), bs=document.getElementById('closerSingle');
  if(!b3 && !bs) return;
  function selectQty(q){
    var tile=document.querySelector('.qtile[data-qty="'+q+'"]');
    if(tile) tile.click();
    return tile;
  }
  function realCta(){ return document.querySelector('.add-to-cart-button[name="add"]'); }
  function scrollToBuy(){
    var el=realCta();
    if(el) el.scrollIntoView({behavior:'smooth',block:'center'});
  }
  if(b3)b3.addEventListener('click',function(){
    selectQty(3);
    var cta=realCta();
    if(cta) cta.click();
    scrollToBuy();
  });
  if(bs)bs.addEventListener('click',function(){
    selectQty(1);
    scrollToBuy();
  });
})();

/* ============================================================
   MANIA KOLLAGEN — neue PDP-Sections ab "Kollagen ist nicht
   einfach Kollagen." (Referenz: mania-pdp-kollagen.html). Reveal
   (.rv/.rv-stagger) und Odometer (.odo) laufen über die bestehenden
   Handler weiter oben in dieser Datei mit. USP-Reihe (.ustk/.urow)
   und Warum-MANIA (.wm/.wm-u) nutzen ebenfalls bereits bestehende
   Handler (siehe oben) — hier nur wirklich neue Komponenten.
   ============================================================ */

/* Herkunft/Prozesskette (pdp-origin-process.liquid): Schritte beim
   Scrollen/Sichtbarwerden einblenden. */
(function(){
  var steps=[].slice.call(document.querySelectorAll('.cstep'));
  if(!steps.length) return;
  if(!('IntersectionObserver' in window)){ steps.forEach(function(s){s.classList.add('in');}); return; }
  var io=new IntersectionObserver(function(entries){entries.forEach(function(en){if(en.isIntersecting){en.target.classList.add('in');io.unobserve(en.target);}});},{threshold:.5});
  steps.forEach(function(s){io.observe(s);});
})();

/* Geschmacksauswahl (pdp-flavor-picker.liquid): zentrierte Karte beim
   Swipe hervorheben + Geschmacks-Balken einblenden, sobald sichtbar. */
(function(){
  var track=document.getElementById('flavTrack');
  var cards=[].slice.call(document.querySelectorAll('#flavTrack .flcard'));
  if(!track||!cards.length) return;
  function upd(){
    var mid=track.scrollLeft+track.clientWidth/2, best=null, bd=1e9;
    cards.forEach(function(c){ var cc=c.offsetLeft+c.offsetWidth/2, d=Math.abs(cc-mid); if(d<bd){bd=d;best=c;} });
    cards.forEach(function(c){ c.classList.toggle('is-current', c===best); });
  }
  var t=false;
  function onS(){ if(!t){ requestAnimationFrame(function(){ upd(); t=false; }); t=true; } }
  track.addEventListener('scroll',onS,{passive:true});
  window.addEventListener('resize',onS,{passive:true});
  upd();
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(entries){entries.forEach(function(en){if(en.isIntersecting){en.target.classList.add('in');io.unobserve(en.target);}});},{threshold:.3});
    cards.forEach(function(c){io.observe(c);});
  } else { cards.forEach(function(c){c.classList.add('in');}); }

  /* "[Name] wählen"-Button: echtes Add-to-Cart für die per SKU zugeordnete
     Variante (siehe pdp-flavor-picker.liquid). Ohne zugeordnete Variante
     (keine/keine passende SKU hinterlegt) Fallback: zur Buy Box scrollen. */
  function gatherGroupedSectionIds(){
    var sections=[];
    document.dispatchEvent(new CartGroupedSections(sections));
    return Array.from(new Set(sections));
  }
  function addToCart(btn,items,source,successLabel){
    if(btn.classList.contains('is-loading')) return;
    var span=btn.querySelector('span');
    var orig=span?span.textContent:btn.textContent;
    function setLabel(t){ if(span) span.textContent=t; else btn.textContent=t; }
    btn.disabled=true;
    btn.classList.add('is-loading');
    setLabel('Wird hinzugefügt …');
    var sectionIds=gatherGroupedSectionIds();
    var body=JSON.stringify({
      items: items,
      sections: sectionIds.join(','),
      sections_url: window.location.pathname
    });
    fetch(FoxTheme.routes.cart_add_url, fetchConfig('json', { body: body }))
      .then(function(res){ return res.json(); })
      .then(function(response){
        btn.classList.remove('is-loading');
        if(response.status){
          btn.disabled=false;
          setLabel('Fehler – bitte erneut versuchen');
          setTimeout(function(){ setLabel(orig); },2200);
          return;
        }
        document.dispatchEvent(new CartAddEvent(response, source, {
          source: source,
          itemCount: items.length,
          sections: response.sections
        }));
        setLabel(successLabel);
        btn.style.background='var(--gold-deep,#C9A23F)';
        setTimeout(function(){ setLabel(orig); btn.style.background=''; btn.disabled=false; },1600);
      })
      .catch(function(err){
        console.error(err);
        btn.disabled=false;
        btn.classList.remove('is-loading');
        setLabel('Fehler – bitte erneut versuchen');
        setTimeout(function(){ setLabel(orig); },2200);
      });
  }
  [].slice.call(document.querySelectorAll('.flcard__pick')).forEach(function(b){
    b.addEventListener('click',function(){
      var variantId=b.dataset.variantId;
      if(!variantId){
        var cta=document.querySelector('.add-to-cart-button[name="add"]');
        if(cta) cta.scrollIntoView({behavior:'smooth',block:'center'});
        return;
      }
      addToCart(b,[{ id: variantId, quantity: 1 }],'pdp-flavor-picker','Hinzugefügt ✓');
    });
  });
  [].slice.call(document.querySelectorAll('.fxc__btn')).forEach(function(b){
    b.addEventListener('click',function(){
      var ownId=b.dataset.variantId, xsId=b.dataset.crosssellVariant;
      var items=[ownId,xsId].filter(Boolean).map(function(id){ return { id: id, quantity: 1 }; });
      if(!items.length) return;
      addToCart(b,items,'pdp-flavor-crosssell','Beide hinzugefügt ✓');
    });
  });
})();

/* Anwendungs-Galerie (pdp-usage-gallery.liquid): Coverflow, Auto-Rotation + Swipe. */
(function(){
  var gal=document.getElementById('cgal'); if(!gal) return;
  var items=[].slice.call(gal.querySelectorAll('.cgitem'));
  var dots=[].slice.call(document.querySelectorAll('#cgdots .cgdot'));
  var n=items.length, cur=0, timer=null;
  if(!n) return;
  function place(){
    var W=gal.clientWidth||440;
    items.forEach(function(it,i){
      var rel=(i-cur+n)%n, p;
      if(rel===0) p={x:0,s:1,o:1,z:3};
      else if(rel===1) p={x:W*0.30,s:.8,o:.55,z:2};
      else if(rel===n-1) p={x:-W*0.30,s:.8,o:.55,z:2};
      else p={x:(rel<n/2?1:-1)*W*0.34,s:.6,o:0,z:1};
      it.style.transform='translate(-50%,-50%) translateX('+p.x+'px) scale('+p.s+')';
      it.style.opacity=p.o; it.style.zIndex=p.z;
    });
    dots.forEach(function(d,i){ d.classList.toggle('on', i===cur); });
  }
  function next(){ cur=(cur+1)%n; place(); }
  function prev(){ cur=(cur-1+n)%n; place(); }
  function start(){ stop(); if(!window.matchMedia('(prefers-reduced-motion: reduce)').matches) timer=setInterval(next,1600); }
  function stop(){ if(timer){ clearInterval(timer); timer=null; } }
  place(); start();
  window.addEventListener('resize',place,{passive:true});
  var sx=null;
  gal.addEventListener('pointerdown',function(e){ sx=e.clientX; stop(); });
  window.addEventListener('pointerup',function(e){ if(sx===null) return; var dx=e.clientX-sx; if(Math.abs(dx)>30){ dx<0?next():prev(); } sx=null; start(); });
  document.addEventListener('visibilitychange',function(){ document.hidden?stop():start(); });
})();

/* Aminosäuren-Modal (pdp-amino-marquee.liquid) */
(function(){
  var m=document.getElementById('aminoModal'), btn=document.getElementById('aminoBtn');
  if(!m||!btn) return;
  function open(){ m.hidden=false; document.body.style.overflow='hidden'; }
  function close(){ m.hidden=true; document.body.style.overflow=''; }
  btn.addEventListener('click',open);
  m.addEventListener('click',function(e){ if(e.target.hasAttribute('data-close')) close(); });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape'&&!m.hidden) close(); });
})();

/* FAQ hell (pdp-faq-accordion.liquid): Akkordeon */
(function(){
  [].slice.call(document.querySelectorAll('.fq')).forEach(function(item){
    var q=item.querySelector('.fq__q'), a=item.querySelector('.fq__a');
    if(!q||!a) return;
    q.addEventListener('click',function(){
      var open=item.classList.contains('is-open');
      document.querySelectorAll('.fq.is-open').forEach(function(o){ if(o!==item){ o.classList.remove('is-open'); var oa=o.querySelector('.fq__a'); if(oa) oa.style.maxHeight=null; } });
      if(open){ item.classList.remove('is-open'); a.style.maxHeight=null; }
      else{ item.classList.add('is-open'); a.style.maxHeight=a.scrollHeight+'px'; }
    });
  });
})();

/* Cross-Sell-Auswahl "Ergänze deine Routine" (pdp-cross-sell-picker.liquid):
   eigenständiges Multi-Add-to-Cart, unabhängig von pdp-bundle-builder.liquid
   (eigene IDs ergList/ergSum/ergCount/ergAdd), gleiche Cart-API/Events wie
   der bestehende Bundle-Builder oben in dieser Datei. */
(function(){
  var list=document.getElementById('ergList');
  if(!list) return;
  var rows=[].slice.call(list.querySelectorAll('.ergrow'));
  var sumEl=document.getElementById('ergSum'), countEl=document.getElementById('ergCount'), btn=document.getElementById('ergAdd');
  function fmt(cents){ return '€'+(cents/100).toFixed(2).replace('.',','); }
  function recalc(){
    var sum=0, n=0;
    rows.forEach(function(r){
      var on=r.classList.contains('is-on')||r.classList.contains('is-fixed');
      if(on){ sum+=parseInt(r.dataset.price,10)||0; n++; }
    });
    if(sumEl) sumEl.textContent=fmt(sum);
    if(countEl) countEl.textContent=n+(n===1?' Produkt ausgewählt':' Produkte ausgewählt');
    if(btn) btn.disabled=(n===0);
  }
  rows.forEach(function(r){
    if(r.dataset.fixed==='1') return;
    r.addEventListener('click',function(){ r.classList.toggle('is-on'); recalc(); });
  });
  function gatherGroupedSectionIds(){
    var sections=[];
    document.dispatchEvent(new CartGroupedSections(sections));
    return Array.from(new Set(sections));
  }
  if(btn){
    btn.addEventListener('click',function(){
      if(btn.disabled||btn.classList.contains('is-loading')) return;
      var chosen=rows.filter(function(r){ return r.classList.contains('is-on')||r.classList.contains('is-fixed'); });
      if(!chosen.length) return;
      var cartItems=chosen.map(function(r){
        var variantId=r.dataset.variantId;
        if(r.dataset.fixed==='1'){
          var liveInput=document.querySelector('form[id^="BuyButtons-ProductForm-"] [ref="variantId"]');
          if(liveInput&&liveInput.value) variantId=liveInput.value;
        }
        return variantId?{ id: variantId, quantity: 1 }:null;
      }).filter(Boolean);
      if(!cartItems.length) return;
      var orig=btn.innerHTML;
      btn.disabled=true; btn.classList.add('is-loading');
      btn.textContent='Wird hinzugefügt …';
      var sectionIds=gatherGroupedSectionIds();
      var body=JSON.stringify({ items: cartItems, sections: sectionIds.join(','), sections_url: window.location.pathname });
      fetch(FoxTheme.routes.cart_add_url, fetchConfig('json', { body: body }))
        .then(function(res){ return res.json(); })
        .then(function(response){
          btn.classList.remove('is-loading');
          if(response.status){ btn.disabled=false; btn.innerHTML=orig; return; }
          document.dispatchEvent(new CartAddEvent(response, 'pdp-cross-sell-picker', { source: 'pdp-cross-sell-picker', itemCount: cartItems.length, sections: response.sections }));
          btn.innerHTML='Hinzugefügt ✓';
          setTimeout(function(){ btn.innerHTML=orig; btn.disabled=false; },1600);
        })
        .catch(function(err){
          console.error(err);
          btn.disabled=false; btn.classList.remove('is-loading'); btn.innerHTML=orig;
        });
    });
  }
  recalc();
})();

/* CTA-Closer "3 Beutel" (pdp-cta-bulk-offer.liquid): Mengenrabatt-Kachel
   wählen (echter Klick auf die bestehende Kachel aus
   blocks/_buybox-quantity-tiles.liquid) + in den Warenkorb / zur Buy Box. */
(function(){
  var b3=document.getElementById('closerTubAdd'), bs=document.getElementById('closerTubSingle');
  if(!b3 && !bs) return;
  function selectQty(q){ var tile=document.querySelector('.qtile[data-qty="'+q+'"]'); if(tile) tile.click(); return tile; }
  function realCta(){ return document.querySelector('.add-to-cart-button[name="add"]'); }
  function scrollToBuy(){ var el=realCta(); if(el) el.scrollIntoView({behavior:'smooth',block:'center'}); }
  if(b3) b3.addEventListener('click',function(){ selectQty(3); var cta=realCta(); if(cta) cta.click(); scrollToBuy(); });
  if(bs) bs.addEventListener('click',function(){ selectQty(1); scrollToBuy(); });
})();
